import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b28183e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-container" }
const _hoisted_2 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_form, {
        onSubmit: _ctx.handleUpdate,
        class: "q-gutter-md"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toggle, {
            modelValue: _ctx.savehistory,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.savehistory) = $event)),
            label: _ctx.t('historysettings.savetagshistory')
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_q_select, {
            disable: !_ctx.savehistory,
            modelValue: _ctx.storageperiod,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storageperiod) = $event)),
            options: _ctx.options,
            label: _ctx.t('historysettings.storageperiod')
          }, null, 8, ["disable", "modelValue", "options", "label"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn, {
              label: _ctx.t('profile.save'),
              class: "full-width",
              size: "lg",
              type: "submit",
              color: "primary",
              loading: _ctx.loading,
              disable: _ctx.loading
            }, null, 8, ["label", "loading", "disable"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["alert", _ctx.successful ? 'alert-success' : 'alert-danger'])
          }, _toDisplayString(_ctx.message), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}